// FeatureChip
import { Chip } from "@mui/material";

//eslint-disable-next-line react/prop-types
function FeatureChip({ feature }) {
  const key = String(feature || "");
  return (
    <Chip
      size="small"
      label={key}
      sx={{
        height: 22,
        borderRadius: 6,
        fontWeight: 600,
        fontSize: 12,
        bgcolor: "#d9f7fc",
        color: "#2c7481",
        border: `1px solid #b2dee5`,
        maxWidth: 180,
        ".MuiChip-label": {
          px: 1.25,
          overflow: "hidden",
        },
      }}
      title={key}
      variant="filled"
    />
  );
}

export default FeatureChip;
